import axios from 'axios';
import config from '../config'; // Ensure this points to your API configuration file

const SourceDatabaseService = {
  // Fetch all source databases
  getAll: async () => {
    const response = await axios.get(`${config.apiBaseUrl}/source-databases`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`, // Add auth if necessary
      },
    });
    return response.data;
  },

  // Fetch a single source database by ID
  get: async (id) => {
    const response = await axios.get(`${config.apiBaseUrl}/source-databases/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`, // Add auth if necessary
      },
    });
    return response.data;
  },

  // Add a new source database
  add: async (data) => {
    const response = await axios.post(`${config.apiBaseUrl}/source-databases`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`, // Add auth if necessary
      },
    });
    return response.data;
  },

  // Update an existing source database
  update: async (id, data) => {
    const response = await axios.put(`${config.apiBaseUrl}/source-databases/${id}`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`, // Add auth if necessary
      },
    });
    return response.data;
  },

  // Delete a source database
  delete: async (id) => {
    const response = await axios.delete(`${config.apiBaseUrl}/source-databases/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`, // Add auth if necessary
      },
    });
    return response.data;
  },
};

export default SourceDatabaseService;
